var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.data.title))]),_c('apex-chart',{attrs:{"options":_vm.options,"series":_vm.series,"height":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }